<template>
  <div class="bgImage h-screen w-full mx-auto">
    <div class="login py-20 flex flex-col justify-center bg-background-academy h-screen
      bg-opacity-50 text-center">
      <div class="title pt-10 text-white">
          <h1 class="text-2xl px-3 md:px-0">{{ $t('login.title') }}</h1>
      </div>
      <form class="flex flex-col justify-center pb-10 w-11/12
        lg:w-1/3 mx-auto text-grey-academy-800"
         @submit.prevent="submit">
        <div class="flex flex-col">
          <input
              type="email" v-model="credentials.email"
              class="mt-10 h-12 border-b-4 border-orange-academy-300 p-4 outline-none
              bg-beige-academy-100 text-lg font-sans-serif"
              placeholder="Email">
          <input
              type="password" v-model="credentials.password"
              class="mt-10 h-12 border-b-4 border-orange-academy-300 p-4 outline-none
              bg-beige-academy-100 text-lg font-sans-serif"
              placeholder="Password">
        </div>
        <div class="flex mt-3 items-center justify-end">
          <a class="text-white font-bold
            font-sans-serif transform hover:scale-105"
            href="/password/reset">
              {{$t('login.reset')}}
          </a>
        </div>
        <button
          class="w-1/3 h-12 mx-auto mt-10 bg-orange-academy-300 text-grey-academy-100 text-lg
                rounded-md hover:text-orange-academy-300 hover:bg-grey-academy-100 shadow-md
                border border-orange-academy-300 font-sans-serif p-1"
          type="submit" ref="login">
          LOGIN
        </button>
      </form>
      <div class="flex mt-12 items-center justify-between w-128 lg:w-1/3 mx-auto">
          <span class="text-white text-md md:text-lg mr-10 font-sans-serif">
            {{ $t('login.title-register') }}</span>
            <router-link to="/registration" class="px-4 h-12 hover:bg-orange-academy-300
              hover:text-grey-academy-100 rounded-md font-sans-serif
              text-orange-academy-300 bg-grey-academy-100 uppercase
              shadow-md border border-orange-academy-300 p-1 flex items-center">
                {{$t('register.register-me')}}
            </router-link>
        </div>

      <modal resizable name="timezone" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import TimezoneMixin from '@/mixins/TimezoneMixin';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      credentials: {
        email: '',
        password: '',
      },

    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },

  mixins: [StreamFunctionsMixin, TimezoneMixin],

  methods: {
    ...mapActions({
      signIn: 'auth/SignIn',
      setNotifications: 'auth/setNotifications',
      isAdmin: 'auth/isAdmin',
    }),

    submit() {
      this.signIn(this.credentials).then(() => {
        this.createNotification('success', this.$t('notifications.login'));
        this.setTimezone();
        dayjs.tz.setDefault(this.choosenTimezone);
        dayjs.locale(this.user.lang);
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
          return;
        }
        this.goToDashboard();
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.credentialsInvalid'));
      });
    },

    resetPassword() {
      window.location = '/password/reset';
    },

  },

};
</script>

<style lang="scss" scoped>
  .bgImage {
    background-image: url('../images/Harp Ecademy.jpg');
    height: 100%;
    background-size: cover;
  }

  ::placeholder {
    color: gray;
    opacity: 0.75;
  }
</style>
